var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavicon6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3463_4840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 16C6.73478 16 6.48043 16.158 6.29289 16.4393C6.10536 16.7206 6 17.1022 6 17.5C6 17.8978 6.10536 18.2794 6.29289 18.5607C6.48043 18.842 6.73478 19 7 19H13C13.2652 19 13.5196 18.842 13.7071 18.5607C13.8946 18.2794 14 17.8978 14 17.5C14 17.1022 13.8946 16.7206 13.7071 16.4393C13.5196 16.158 13.2652 16 13 16H7Z",
    fill: "#7A67FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M10 0C5.39754 0 1.66666 3.58165 1.66666 8C1.66666 11.0569 3.45294 13.7139 6.07843 15.0602V16.9412C6.07843 17.1908 6.18172 17.4302 6.36558 17.6067C6.54944 17.7832 6.7988 17.8824 7.05882 17.8824H12.9412C13.2012 17.8824 13.4506 17.7832 13.6344 17.6067C13.8183 17.4302 13.9216 17.1908 13.9216 16.9412V15.0607C16.5471 13.7139 18.3333 11.0574 18.3333 8C18.3333 3.58165 14.6024 0 10 0Z",
    fill: "url(#paint0_linear_3463_4840)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3463_4840)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.12624 16.3808C6.17357 16.7043 6.25505 17.0018 6.36573 17.2468C6.54959 17.6537 6.79895 17.8823 7.05897 17.8823H12.9413C13.2013 17.8823 13.4507 17.6537 13.6346 17.2468C13.7454 17.0015 13.827 16.7035 13.8743 16.3794C13.8269 15.6511 13.7454 14.9814 13.6347 14.43C13.4509 13.5144 13.2015 13 12.9415 13H7.05912C6.7991 13 6.54973 13.5144 6.36587 14.43C6.25509 14.9817 6.17355 15.6519 6.12624 16.3808Z",
    fill: "#8760EA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.87106 6.73228C6.7489 6.85587 6.67643 7.02084 6.66766 7.19529C6.65889 7.36974 6.71443 7.54129 6.82356 7.67675L6.87106 7.7304L9.30148 10.1855L9.30101 15.2311H10.6981V10.185L13.128 7.7304C13.2562 7.60276 13.3307 7.43005 13.336 7.24828C13.3412 7.06651 13.2769 6.88969 13.1563 6.75469C13.0357 6.61968 12.8683 6.53691 12.6888 6.52362C12.5093 6.51033 12.3317 6.56754 12.1929 6.68334L12.1398 6.73181L9.99954 8.89511L7.85925 6.73181C7.79438 6.66622 7.71735 6.61418 7.63257 6.57868C7.54779 6.54318 7.45692 6.5249 7.36515 6.5249C7.27338 6.5249 7.18251 6.54318 7.09773 6.57868C7.01295 6.61418 6.93593 6.66622 6.87106 6.73181V6.73228Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3463_4840",
    x: 3.62624,
    y: 10.5,
    width: 12.748,
    height: 9.88232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25,
    result: "effect1_foregroundBlur_3463_4840"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3463_4840",
    x1: 18.3333,
    y1: 8.94118,
    x2: 1.66666,
    y2: 8.94118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C082FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7967FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3463_4840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6667,
    height: 20,
    fill: "white",
    transform: "matrix(-1 0 0 1 18.3333 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavicon6);
export default __webpack_public_path__ + "static/media/navicon6.fe1b74be6434e06fecd05a6db3872dfc.svg";
export { ForwardRef as ReactComponent };